import request from './http'

import global from "../global";

/**
 * 获取用户列表
 * @param {} params 
 * @returns 
 */
export function GETUSERLIST (params) {
  return request({
    baseURL: global.baseURL,
    url: "/userManage/findByPage/" + params.pageNo + "/" + params.pageSize,
    method: 'post',
    data: params
  })
}

/**
 * 获取用户信息
 * @param {*} params 
 * @returns 
 */
export function GETUSERDETAILS (params) {
  return request({
    baseURL: global.baseURL,
    url: "/userManage/findById/" + params.id,
    method: 'post',
    data: params
  })
}

/**
 * 新增或更新用户信息
 * @param {*} params 
 * @returns 
 */
export function SAVEUSERINFO (params) {
  return request({
    baseURL: global.baseURL,
    url: "/userManage/saveUserInfo",
    method: 'post',
    data: params
  })
}

/**
 * 更新用户密码
 * @param {*} params 
 * @returns 
 */
 export function RESETUSERPWD (params) {
  return request({
    baseURL: global.baseURL,
    url: "/userManage/resetUserPwd",
    method: 'post',
    data: params
  })
}


/**
 * 删除用户信息
 * @param {*} params 
 * @returns 
 */
export function DELUSERS (params) {
  return request({
    baseURL: global.baseURL,
    url: "/userManage/deleteById/" + params.id,
    method: 'delete',
    data: params
  })
}

/**
 * 获取所有的角色列表
 * @param {*} params 
 * @returns 
 */
export function GETROLELIST(params){
  return request({
    baseURL: global.baseURL,
    url:'/role/findAll',
    method:'post',
    data: params
  });
}

/**
 * 获取所有的场馆列表
 * @param {*} params 
 * @returns 
 */
 export function GETSITELIST(params){
  return request({
    baseURL: global.baseURL,
    url:'/site/findAll',
    method:'post',
    data: params
  });
}

/**
 * 删除角色信息
 * @param {*} params 
 * @returns 
 */
 export function DELROLES (params) {
  return request({
    baseURL: global.baseURL,
    url: "/role/deleteById/" + params.id,
    method: 'delete',
    data: params
  })
}

/**
 * 获取所有的角色列表分页数据
 * @param {*} params 
 * @returns 
 */
 export function SEARCHROLELIST(params){
  return request({
    baseURL: global.baseURL,
    url:'/role/search/'+ params.pageNo + "/" + params.pageSize,
    method:'post',
    data: params
  });
}

/**
 * 新增或更新角色信息
 * @param {*} params 
 * @returns 
 */
 export function SAVEROLEINFO (params) {
  return request({
    baseURL: global.baseURL,
    url: "/role/save",
    method: 'post',
    data: params
  })
}

/**
 * 获取所有的用户操作日志列表分页数据
 * @param {*} params 
 * @returns 
 */
 export function SEARCHLOGLIST(params){
  return request({
    baseURL: global.baseURL,
    url:'/userManage/findLogByPage/'+ params.pageNo + "/" + params.pageSize,
    method:'post',
    data: params
  });
}

export const userInfoForm = {
  userName:[
    'userName',    //必填输入控件唯一标志
    {
      rules: [{
        required: true,    //是否必填
        message: "请填写用户名",     //必填验证提示，
      }]
    }
  ],
  userPasswd:[
    'userPasswd',    //必填输入控件唯一标志
    {
      rules: [{
          required: true,    //是否必填
          message: "请输入登录密码",     //必填验证提示，
          whitespace: true, //必选时，空格是否被视为错误
        },
        {
          pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,12}$/,
          message: "密码长度为6-12位,必须由字母、数字组成，区分大小写"
        }
      ]
    }
  ],
  confirmPassword:[
    'confirmPassword',    //必填输入控件唯一标志
    {
      initialValue: '',
      rules: [{
        required: true,    //是否必填
        message: "请输入确认密码",     //必填验证提示，
        whitespace: true, //必选时，空格是否被视为错误
      },
      {
        pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,12}$/,
        message: "密码长度为6-12位,必须由字母、数字组成，区分大小写"
      }]
    }
  ],
  phone:[
    'phone',    //必填输入控件唯一标志
    {
      rules: [{
        required: true,    //是否必填
        message: "请填写手机号",     //必填验证提示，
      }]
    }
  ],
  userRealName:[
    'userRealName',    //必填输入控件唯一标志
    {
      rules: [{
        required: true,    //是否必填
        message: "请填写真实姓名",     //必填验证提示，
      }]
    }
  ],
  userRoles:[
    'userRoles',    //必填输入控件唯一标志
    {
      rules: [{
        required: true,    //是否必填
        message: "请选择授予角色",     //必填验证提示，
      }]
    }
  ],
  userSites:[
    'userSites',    //必填输入控件唯一标志
    {
      rules: [{
        required: true,    //是否必填
        message: "请选择授予场馆",     //必填验证提示，
      }]
    }
  ],
  sex:[
    'sex',    //必填输入控件唯一标志
    {
      rules: [{
        required: false,    //是否必填
        message: "",     //必填验证提示，
      }]
    }
  ],
  valid:[
    'valid',    //必填输入控件唯一标志
    {
      initialValue:1,
      rules: [{
        required: false,    //是否必填
        message: "",     //必填验证提示，
      }]
    }
  ],
};

export const roleInfoForm = {
  roleName:[
    'roleName',    //必填输入控件唯一标志
    {
      rules: [{
        required: true,    //是否必填
        message: "请填写角色名称",     //必填验证提示，
      }]
    }
  ],
  roleDesc:[
    'roleDesc',    //必填输入控件唯一标志
    {
      rules: [{
        required: true,    //是否必填
        message: "请填写角色描述信息",     //必填验证提示，
      }]
    }
  ],
  valid:[
    'valid',    //必填输入控件唯一标志
    {
      initialValue:1,
      rules: [{
        required: false,    //是否必填
        message: "",     //必填验证提示，
      }]
    }
  ],
};


// WEBPACK FOOTER //
// ./static/js/API/systemManageApis.js